import { useTranslation, Trans } from "react-i18next";

export default function StoriesSection() {
  const { t } = useTranslation();

  // rozet metinlerini \n ile çok satırlı tutuyoruz
  const badges = [
    t("stories_badge_1"),
    t("stories_badge_2"),
    t("stories_badge_3"),
  ];

  return (
    <section className="w-full bg-[#0b1224] sm:py-12 px-4 flex flex-col items-center">
      {/* Başlıklar */}
      <h2 className="text-[28px] sm:text-4xl md:text-5xl font-light text-[#e8d1b9] text-center tracking-tight">
        {t("stories_title_top")}
      </h2>
      <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#e8d1b9] text-center mt-2 whitespace-pre-line">
        {t("stories_title_main")}
      </h3>

      {/* Açıklama (Trans ile inline vurgular eklemek istersen tag kullanabilirsin) */}
      <p className="max-w-3xl text-white/90 text-center mt-6 sm:mt-8 mb-10 sm:mb-12 text-[15px] sm:text-base md:text-lg leading-relaxed">
        <Trans i18nKey="stories_desc" />
      </p>

      {/* Daireler */}
      <div
        className="
          relative
          flex flex-wrap items-center justify-center
          gap-3 sm:gap-4
          lg:gap-0 lg:-space-x-5
          select-none
        "
      >
        {badges.map((text, idx) => (
          <div
            key={idx}
            className="
              w-28 h-28 sm:w-40 sm:h-40 md:w-48 md:h-48
              rounded-full
              bg-[#101a37]
              ring-2 ring-[#314a8e]
              shadow-[0_10px_30px_-12px_rgba(0,0,0,0.6)]
              flex items-center justify-center text-center
              text-[#e8d1b9]
              text-sm sm:text-lg md:text-2xl font-semibold
              transition-transform duration-200 hover:scale-[1.03]
              px-2
            "
          >
            <div className="leading-snug whitespace-pre-line">
              {text}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
